import { Checkbox } from "@certn/cascadia-react";
import { CheckboxGroup } from "@certn/cascadia-react/components/inputs/checkbox/checkbox-group/CheckboxGroup";
import { slugifyPath } from "@certn/utils";
import { useContext } from "react";

import { CascadiaJsonFormContext } from "../CascadiaJsonFormContext";
import { SummaryItem } from "../components/SummaryItem";
import {
  CascadiaOneOfProps,
  withCascadiaOneOfProps,
} from "../wrappers/withCascadiaOneOfProps";

export function EnumCheckboxGroupControl(props: CascadiaOneOfProps) {
  const { options, description, path } = props;

  const { isSummaryForPath, formID } = useContext(CascadiaJsonFormContext);

  if (isSummaryForPath?.(path)) {
    const selectedOption = props.items.find(
      (item) => item.value === props.data
    );

    return (
      <SummaryItem label={props.label}>
        {selectedOption?.value || props.data}
      </SummaryItem>
    );
  }
  return (
    <CheckboxGroup
      description={description}
      errors={props.errors}
      isDisabled={!props.enabled}
      isInvalid={props.invalid}
      isRequired={props.required}
      label={props.label}
      name={props.path}
      onChange={props.setValue}
      value={props.data}
      children={props.items.map((item, index) => (
        <Checkbox
          key={index}
          value={item.value}
          isCard={options?.card}
          description={item.description}
          onBlur={props.setTouched}
          testID={
            formID
              ? `${formID}-${slugifyPath(props.path)}-checkbox`
              : `${slugifyPath(props.path)}-checkbox`
          }
        >
          {item.label}
        </Checkbox>
      ))}
      // testID={`check-engine-${slugify(props.label)}-checkbox-group`}
      // changing to use path instead of label because label is likely to be translated
      testID={
        formID
          ? `${formID}-${slugifyPath(props.path)}-enum-checkbox-group`
          : `${slugifyPath(props.path)}-enum-checkbox-group`
      }
    />
  );
}
EnumCheckboxGroupControl.displayName = "EnumCheckboxGroupControl";

export const EnumCheckboxGroupRenderer = withCascadiaOneOfProps(
  EnumCheckboxGroupControl
);
